import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A78C1259-0DB5-4793-9EA9-DD69FEB337A8
 * name volume-mute
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-mute.svg
 * tags
 * - Audio 
 * - Cellphone / Phone 
 */
export const VolumeMuteIcon = createSvgIcon(<><path d="M3,9H7L12,4V20L7,15H3V9M16.59,12L14,9.41L15.41,8L18,10.59L20.59,8L22,9.41L19.41,12L22,14.59L20.59,16L18,13.41L15.41,16L14,14.59L16.59,12Z" /></>, 'VolumeMuteIcon');
export default VolumeMuteIcon